var _circle, _path, _circle2, _mask, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartTopic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.1055,
    cy: 27,
    r: 18,
    fill: "#5568FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1055 25.268C35.4388 26.0378 35.4388 27.9623 34.1055 28.7321L25.1055 33.9282C23.7721 34.698 22.1055 33.7358 22.1055 32.1962L22.1055 21.8039C22.1055 20.2643 23.7721 19.302 25.1055 20.0718L34.1055 25.268Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 25,
    stroke: "#4E4D65",
    strokeWidth: 4
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_573_222",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.293 2.02464C24.1812 0.993288 24.927 0.0597132 25.9636 0.0198828C30.1177 -0.139732 34.2534 0.662308 38.0467 2.36321C38.9933 2.78765 39.336 3.93233 38.8468 4.84713V4.84713C38.3576 5.76192 37.2219 6.0993 36.2706 5.68553C33.1506 4.32848 29.7701 3.67288 26.369 3.76527C25.332 3.79344 24.4047 3.05599 24.293 2.02464V2.02464Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.293 2.02464C24.1812 0.993288 24.927 0.0597132 25.9636 0.0198828C30.1177 -0.139732 34.2534 0.662308 38.0467 2.36321C38.9933 2.78765 39.336 3.93233 38.8468 4.84713V4.84713C38.3576 5.76192 37.2219 6.0993 36.2706 5.68553C33.1506 4.32848 29.7701 3.67288 26.369 3.76527C25.332 3.79344 24.4047 3.05599 24.293 2.02464V2.02464Z",
    stroke: "#5568FE",
    strokeWidth: 8,
    mask: "url(#path-4-inside-1_573_222)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartTopic);
export default __webpack_public_path__ + "static/media/startTopic.9a6c78da43fdaf97026655568f96424f.svg";
export { ForwardRef as ReactComponent };